import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-private-coupon",
  templateUrl: "./private-coupon.component.html",
  styleUrls: ["./private-coupon.component.css"],
})
export class PrivateCouponComponent implements OnInit {
  working: boolean;

  constructor() {}

  ngOnInit() {}
}
